<template>
  <div class="container-fluid">
    <!-- Container-fluid starts-->
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-6">
            <KundeWohnungen />
          </div>
          <div class="col-6">
            <KundeBoardMessages />
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-3"><widgetClock /></div>
          <div class="col-3"><calendar /></div>
          <div class="col-3">
            <Ansprechpartner show_themen="Kundenportal" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Container-fluid Ends-->
</template>

<script>
import widgetClock from "@/widget/clock.vue";
import calendar from "@/widget/calendar.vue";
import KundeWohnungen from "@/widget/kunde/KundeWohnungen.vue";
import Ansprechpartner from "@/widget/Ansprechpartner.vue";
import KundeBoardMessages from "@/widget/kunde/KundeBoardMessages.vue";

export default {
  name: "KundeDashboard",
  components: {
    widgetClock,
    calendar,
    KundeWohnungen,
    Ansprechpartner,
    KundeBoardMessages,
  },
  async created() {},
  methods: {},
};
</script>
